import { IconDownload } from '@tabler/icons';
import { ConfigProvider, Modal, Pagination, Row, Table } from 'antd';
import classNames from 'classnames/bind';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import styled from 'styled-components';
import packAPI from '~/api/PackAPI';
import { IMAGES } from '~/assets/assetsPath';
import CancelModal from '~/components/FormCancel';
import { getNumberWithCommas } from '~/utils';
import EmptyForm from '../Empty';
import styles from './FormMyUseCard.module.scss';

const cx = classNames.bind(styles);
const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const MyUseCardModal = ({ record }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const [myUseCard, setMyUseCard] = useState([]);
    const [myHistoryUseCard, setMyHistoryUseCard] = useState([]);

    const [isShowQRCode, setIsShowQRCode] = useState(false);
    const [qrCodeZoom, setQRCodeZoom] = useState('');
    const [isShowShare, setIsShowShare] = useState(false);
    const [defaultExpandAllRows, setDefaultExpandAllRows] = useState(false);

    const [isShowAsk, setIsShowAsk] = useState(false);
    const [checkedStatus, setCheckedStatus] = useState(false);
    const [idUpdate, setIdUpdate] = useState('');
    const [textNoti, setTextNoti] = useState('');

    const onAgreeAsk = async () => {
        try {
            await packAPI.updateStatusConfirm(idUpdate, {
                is_confirm: checkedStatus,
            });
            handleGetMyUserCard(pagination.page);
        } catch (error) {}
        setIsShowAsk(false);
    };
    const onCancelAsk = () => {
        setIsShowAsk(false);
    };

    // const onChangeSwitchStatus = (checked, id) => {
    //     setIsShowAsk(true);
    // setTextNoti(checked ? 'Are you sure you have received the money' : 'Are you sure you have not received the money');
    //     setIdUpdate(id);
    //     setCheckedStatus(checked);
    // };

    const columns = [
        {
            title: () => {
                return <div className={cx('title_header')}>STT</div>;
            },
            render: (text, record, index) => <div>{(pagination.page - 1) * 10 + index + 1}</div>,
            align: 'center',
            dataIndex: 'STT',
            key: 'STT',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Value</div>;
            },
            render: (text, record, index) => <div>{getNumberWithCommas(record.value)} d</div>,
            align: 'center',
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Last loaded</div>;
            },
            render: (item) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {moment(item, 'x').format('HH:mm, DD/MM/YYYY')}
                </div>
            ),
            align: 'center',
            dataIndex: 'date_submit_pack_unix',
            key: 'date_submit_pack_unix',
        },
    ];

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const handleGetMyUserCard = async (page) => {
        try {
            setIsLoading(true);
            let cards = [];
            const params = {
                fields: '["$all", {"user": ["$all"]}, {"owner": ["$all"]}]',
                filter: `{"$and": [{"owner_id": "${userInfo?.id}"}, {"user_id": "${record?.user_id}"}]}`,
                order: '[["date_submit_pack_unix", "DESC"]]',
                // limit: pagination.limit,
                // page: page,
            };
            const res = await packAPI.getListPackAPI_HistoryUserUsing(userInfo?.id, params);

            if (res.code === 200) {
                cards = res.results.objects.rows.map((item, index) => ({
                    key: index,
                    ...item,
                }));
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / pagination.limit),
                });
            }
            setIsLoading(false);
            setMyUseCard(cards);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    const handleChangePage = (page) => {
        setPagination({ ...pagination, page });
        handleGetMyUserCard(page);
        window.scrollTo(0, 0);
    };

    const handleSaveQRCode = (image) => {
        saveAs(image, `qr-code-booking-${moment().valueOf()}.png`);
    };

    useEffect(() => {
        handleGetMyUserCard(pagination.page);
        //eslint-disable-next-line
    }, []);

    const mountRef = useRef(true);
    useEffect(() => {
        if (mountRef.current) {
            mountRef.current = false;
            return;
        }
        const script = document.createElement('script');

        script.src = 'https://sp.zalo.me/plugins/sdk.js';

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isShowShare]);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                {/* <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 2, children: 1 }} />
                            </Row>
                        </div>
                    </div>
                </div> */}
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>Tag usage history</Row>
                    <div className={cx('right_container')}>
                        {/* <div className={cx('table_container')}> */}
                        <Row>
                            <ConfigProvider renderEmpty={() => <EmptyForm />}>
                                <Table
                                    className={cx('table')}
                                    columns={columns}
                                    // onRow={(record, rowIndex) => {
                                    //     // return {
                                    //     //     onClick: event => { }, // click row
                                    //     // };
                                    // }}
                                    // rowKey={record => record.user_id}
                                    // expandable={{
                                    //     expandedRowRender,
                                    //     // rowExpandable: (record) => expandRowMyUseCard(record),
                                    //     // onExpand: (expanded, record) => expandRowMyUseCard(expanded, record)
                                    // }}
                                    dataSource={myUseCard}
                                    pagination={false}
                                    loading={isLoading}
                                />
                            </ConfigProvider>
                        </Row>
                        {myUseCard?.length ? (
                            <Row justify="center" style={{ marginTop: '30px' }}>
                                <PaginationCustom>
                                    <Pagination
                                        defaultCurrent={1}
                                        current={pagination?.page}
                                        total={pagination?.total_item}
                                        pageSize={pagination?.limit}
                                        onChange={handleChangePage}
                                    />
                                </PaginationCustom>
                            </Row>
                        ) : null}
                        {/* </div> */}
                    </div>
                </div>
            </div>
            {isShowQRCode && (
                <Modal
                    centered
                    title="QR Code"
                    visible={isShowQRCode}
                    onCancel={() => setIsShowQRCode(false)}
                    maskClosable={false}
                    footer={null}
                    width={500}
                    // className="otp-modal"
                >
                    <div style={{ padding: '10px 10px' }}>
                        <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                    </div>
                </Modal>
            )}
            {isShowShare && (
                <Modal
                    centered
                    title="Share"
                    visible={isShowShare}
                    onCancel={() => setIsShowShare(false)}
                    maskClosable={false}
                    footer={null}
                    width={500}
                    // className="otp-modal"
                >
                    <Row style={{ padding: '10px 10px' }}>
                        <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                    </Row>
                    <Row justify="center" align="middle">
                        <div
                            className="zalo-share-button"
                            data-href={qrCodeZoom}
                            data-oaid="579745863508352884"
                            data-layout="4"
                            data-color="blue"
                            data-share-type="2"
                            data-customize="true"
                        >
                            <div className={cx('share_zalo')}>
                                <img src="https://stc.sp.zdn.vn/share/logo_white_s_2x_40.png" alt="zaloImg" />
                            </div>
                        </div>

                        <FacebookShareButton url={qrCodeZoom}>
                            <FacebookIcon size={52} className={cx('share_facebook')} />
                        </FacebookShareButton>
                        <div
                            style={{
                                cursor: 'pointer',
                                color: 'black',
                            }}
                            onClick={() => handleSaveQRCode(qrCodeZoom)}
                        >
                            <IconDownload size={50} />
                        </div>
                    </Row>
                </Modal>
            )}
            {isShowAsk && (
                <Modal
                    centered
                    visible={isShowAsk}
                    onCancel={() => setIsShowAsk(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal onAgreeCancel={onAgreeAsk} onRejectCancel={onCancelAsk} text={textNoti} />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default MyUseCardModal;
